import { useParams } from "react-router-dom";
import Error from "../../../Components/Error";
import Loading from "../../../Components/Loading";
import { useGetPostBlogQuery } from "../../../Redux/Apis/blogApi";
import parse from 'html-react-parser';
import { fa_date, fa_dateـetime, fa_number } from "../../../utils/PersianNum";
import Breadcrumb from "../Components/Breadcrumb";
import RecentPost from "../Components/RecentPost";

function Post() {
    let { id } = useParams();

    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error,
    } = useGetPostBlogQuery(id)
    
    if(isLoading)
        return <Loading/>

    else if(isError)
        return <Error data={error}/>

    else if(isSuccess) {
        return (
            <>
            <Breadcrumb name={data.title} image={data.image}/>
            <div className="mt-100 mb-150">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="single-article-section">
                                <div className="single-article-text">
                                    <div className="single-artcile-bg" style={{backgroundImage: `url(${data.image})`}}></div>
                                    <p className="blog-meta">
                                        <span className="author"><i className="fas fa-folder-open"></i>{data.BlogCategory.name}</span>
                                        <span className="date"><i className="fas fa-calendar"></i>{fa_dateـetime(data.create_date)}</span>
                                    </p>
                                    <h2>{data.title}</h2>
                                    {parse(data.body)}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="sidebar-section">
                                <RecentPost site_id={data.site_id}/>
                                <div className="archive-posts">
                                    <h4>اطلاعات پست</h4>
                                    <ul>
                                        <li><p>تعداد بازدید: {fa_number(data.views)}</p></li>
                                        <li><p>تاریخ ایجاد: {fa_date(data.create_date)}</p></li>
                                        <li> <p>آخرین ویرایش: {fa_date(data.update_date)}</p></li>
                                    </ul>
                                </div>
                                <div className="tag-section">
                                    <h4>تگ ها</h4>
                                    <ul>
                                        {
                                            data.tags && data.tags.split(',').map(value =>
                                                <li>{value}</li>
                                            )
                                        }
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </>
        );
    }
}

export default Post;